<template>
<div class="view">
  <div class="border-folder">
    <Diagram v-if="selectedPage === 'hmsDiagram'" />
    <Chart v-else/>
  </div>
</div>
</template>

<script setup>
  import Diagram from '@/HmsDiagram.vue'
  import Chart from '@/HmsChartV2Old.vue'
  import {computed} from 'vue'
 
  const showOld = new URLSearchParams (window.location.search).has('old')
  const selectedPage = computed(() => {
    if (showOld) {
      return 'chart'
    }
    return 'hmsDiagram'
  })

  
</script>

<style>
body {
  background-color: #4F4C00;
}
</style>

<style scoped>
* {
  --white-1: #EBF5FF;
  --tan-1: #F3F2E3;
  --tan-2: #DEDCB2;
  --tan-3: #c8c58c;
  --tan-4: #969462;
  --green-1: #B4AA00;
  --green-2: #9D9500;
  --green-3: #676200;
  --green-4: #4F4C00;
  --green-5: #494127;
}
.view {
  font-family: Calibri, 'Trebuchet MS', sans-serif;
}
.border-folder {
  width: 1735px;
  height: 1000px;
  border: 4px solid var(--tan-3);
  border-radius: 5px;
  margin: auto;
  overflow: hidden;
  background-image: url("./assets/texture_depthPattern4.jpg");
}
#app:fullscreen .border-folder {
  border: none;
}
</style>
